module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado13.b9289f4e.svg";